import {useMemo} from 'react'
import {useLocation} from 'react-router-dom'

const useSlugUrlRedirect = (isServer, contentId, content) => {
    const location = useLocation()

    const {shouldRedirect, redirectUrl} = useMemo(() => {
        if (!isServer || content?.c_slugUrl === undefined || content?.c_slugUrl === '')
            return {shouldRedirect: false}
        const slugUrl = new URL(
            content?.c_slugUrl.replace('/s/', '/'),
            // we only use pathname, so it doesn't matter what the origin is
            'https://www.stokke.com'
        )
        // location decodes unicode characters, so we need to encode them to compare with slugUrl
        const locationUrl = new URL(
            location.pathname,
            // we only use pathname, so it doesn't matter what the origin is
            'https://www.stokke.com'
        )

        const shouldRedirect =
            [locationUrl.pathname, slugUrl.pathname].every((url) =>
                url.includes(`${contentId}.html`)
            ) && !slugUrl.pathname.includes(locationUrl.pathname)

        return {
            shouldRedirect,
            redirectUrl: slugUrl.pathname + location.search
        }
    }, [contentId, location?.pathname, location.search, content?.c_slugUrl, isServer])

    if (shouldRedirect) {
        return redirectUrl
    }
}

export default useSlugUrlRedirect
